module.exports = __webpack_public_path__ + "img/ccompany-honor-MHRA-20240411.0ccd3a55.jpg";